import { render } from "./NewMember.vue?vue&type=template&id=28574d54&scoped=true"
import script from "./NewMember.vue?vue&type=script&lang=js"
export * from "./NewMember.vue?vue&type=script&lang=js"

import "./NewMember.vue?vue&type=style&index=0&id=28574d54&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28574d54"]])

export default __exports__